import { RowMiddle } from 'layout/Components/Row'
import React from 'react'
import styled, { css } from 'styled-components'
import { Icons } from 'svgs'
import theme from 'theme'
import Flex from 'UIKit/Box/Flex'
import IconButton from 'UIKit/Button/IconButton'

const FilterInput: React.FC<{
  onClick: () => void
  selectedName: React.ReactNode
  logo: React.ReactNode
}> = ({ onClick, selectedName, logo }) => {
  const disabled = !onClick

  return (
    <FilterInputContainer disabled={disabled} onClick={() => !disabled && onClick()}>
      <RowMiddle flex={1} gap="8px">
        {logo}
        {selectedName}
      </RowMiddle>

      {!disabled && (
        <IconButton width={12}>
          <Icons.ChevronRightIcon width="8px" />
        </IconButton>
      )}
    </FilterInputContainer>
  )
}

export const FilterInputContainer = styled(Flex)<{ disabled?: boolean }>`
  overflow: hidden;
  border-radius: var(--pm-trigger-radius);
  align-items: center;
  color: ${({ color }) => color};

  ${({ disabled }) =>
    disabled &&
    css`
      background: var(--pm-card-disabled);
      cursor: not-allowed;
      color: var(--pm-text-disabled);

      & > * {
        color: var(--pm-text-disabled);
      }
    `};
`

FilterInputContainer.defaultProps = {
  height: 'var(--pm-trigger-height)',
  padding: '8px 12px',
  background: `var(--pm-card, ${theme.colors.backgroundAlt14})`,
  gap: '8px',
  color: 'white',
}

export default FilterInput
